import { render, staticRenderFns } from "./index.vue?vue&type=template&id=583fa9ef&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=583fa9ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../1013/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583fa9ef",
  null
  
)

export default component.exports